import {
  ATTENDANCE_LOADING,
  GET_ATTENDANCE,
  GET_ATTENDANCE_SUCCESS,
  GET_ATTENDANCE_FAIL,
  ADD_ATTENDANCE_SUCCESS,
  ADD_ATTENDANCE_FAIL,
  DELETE_ATTENDANCE_SUCCESS,
  DELETE_ATTENDANCE_FAIL,
  UPDATE_ATTENDANCE_SUCCESS,
  UPDATE_ATTENDANCE_FAIL,
  ATTENDANCE_RESET
} from "./actionType";

const INIT_STATE = {
  attendances: [],
  error: {},
};

const Attendance = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ATTENDANCE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ATTENDANCE:
          return {
            ...state,
            attendances: action.payload.data,
            isAttendanceCreated: false,
            isAttendanceSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ATTENDANCE_FAIL:
      switch (action.payload.actionType) {
        case GET_ATTENDANCE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAttendanceCreated: false,
            isAttendanceSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ATTENDANCE: {
      return {
        ...state,
        isAttendanceCreated: false,
        loading: true,
      };
    }

    case ATTENDANCE_LOADING: {
      return {
        ...state,
        isAttendanceCreated: false,
        loading: true,
      };
    }

    case ADD_ATTENDANCE_SUCCESS:
      return {
        ...state,
        isAttendanceCreated: true,
        loading: false,
        attendances: [action.payload.data, ...state.attendances],
      };

    case ADD_ATTENDANCE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        attendances: state.attendances.filter(
          attendance => attendance.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ATTENDANCE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        attendances: state.attendances.map(attendance =>
          attendance.id.toString() === action.payload.data.id.toString() ? { ...attendance, ...action.payload.data } : attendance
        ),
      };

    case UPDATE_ATTENDANCE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ATTENDANCE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Attendance;